import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface Chip {
  label: string;
  count?: number;
  active: boolean;
  onClick: () => void;
}

interface Props {
  chips: Chip[];
}

export const QuickFilterChips: React.FC<Props> = ({ chips }) => {
  const { darkMode } = useTheme();
  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((chip) => (
        <button
          key={chip.label}
          onClick={chip.onClick}
          className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            chip.active
              ? 'bg-violet-900/40 text-violet-300 ring-1 ring-violet-500/30'
              : darkMode ? 'bg-gray-800 text-gray-400 hover:bg-gray-700' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
          }`}
        >
          {chip.label}
          {chip.count != null && (
            <span className={`ml-1.5 ${chip.active ? 'text-violet-400' : 'text-gray-500'}`}>{chip.count}</span>
          )}
        </button>
      ))}
    </div>
  );
};
